import { useParams, useNavigate, Link } from "react-router-dom";
import { MAGAZINES } from "../data/magazines";
import "../css/magazineDetails.css";

/* ── Featured Stories — swap for real data / an API call whenever ready.
   Each card links through to ArticlePage.jsx via /article/:id ── */
const FEATURED_STORIES = [
{
  _id: "AI_Virtual",
  category: "Leadership",
  title: "AI Virtual: How Founder Hamid Kohan Helps Businesses Improve Productivity Through Artificial Intelligence",
  excerpt: "Hamid Kohan, founder of AI Virtual, is focused on helping businesses improve productivity, streamline workflows, and automate daily operations through artificial intelligence and intelligent automation solutions.",
  imageUrl: "https://xenogeneic-turquoise-isfetp2h.edgeone.dev/Hamid%20kohan%20artical.png",
},
{
  _id: "Dana_Hatch",
  category: "Leadership",
  title: "Dana Hatch: Founder of The Unfiltered Method — Redefining Authenticity, Confidence, and Personal Transformation",
  excerpt: "Dana Hatch, founder of The Unfiltered Method, is redefining personal transformation by helping individuals embrace authenticity, build confidence, and create meaningful change...",
  imageUrl: "https://ordinary-amber-smigi1lm.edgeone.dev/file.png",
},
{
  _id: "p2",
  category: "Leadership",
  title: "Hande Kizir: The Global IT Recruitment Leader Who Places the Right Person in the Right Place",
  excerpt: "Hande Kizir is a global IT recruitment leader dedicated to connecting exceptional talent with the right opportunities, helping organizations build stronger teams while empowering professionals to grow their careers...",
  imageUrl: "https://alive-jade-wxemzyzg.edgeone.dev/Hande%20Kizir.png",
},
];

export default function MagazineDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const magazine = MAGAZINES.find(
    m => String(m._id) === String(id)
  );

  if (!magazine) {
    return <h2>Magazine Not Found</h2>;
  }

  const hasFlipbook = Boolean(magazine.flipbookUrl && magazine.flipbookUrl.trim());

  const scrollToFlipbook = (e) => {
    if (!hasFlipbook) return; // no embed yet — let the link fall through to /magazine
    e.preventDefault();
    document.getElementById("magazine-flipbook")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="magazine-details">

      <button
        className="back-btn"
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

      <div className="magazine-content">

        <div className="magazine-cover">
          <img
            src={magazine.imageUrl}
            alt={magazine.title}
          />
        </div>

        <div className="magazine-info">

          <h1>{magazine.title}</h1>

          {/* <div className="mag-meta">
            <span>📂 {magazine.category}</span>
            <span>📅 {magazine.year}</span>
          </div> */}

          <p className="mag-description">
            {magazine.description ||
              "Discover inspiring stories, leadership insights, business strategies, and exclusive interviews with industry pioneers featured in this edition."}
          </p>

          {/* <a
            href="/magazine"
            className="mag-btn"
            onClick={scrollToFlipbook}
          >
            Read Magazine →
          </a> */}

        </div>

      </div>

      {/* ── Flipbook viewer ── */}
      {hasFlipbook ? (
        <div className="magazine-flipbook" id="magazine-flipbook">
          <div className="flipbook-frame-wrap">
            <iframe
              className="flipbook-iframe"
              src={magazine.flipbookUrl}
              title={`${magazine.title} — flipbook`}
              loading="lazy"
              allow="fullscreen"
              allowFullScreen
            />
            {/* Visual-only mask over the PubHTML5 logo in the embed's
                toolbar. This can't remove the branding (it's inside a
                cross-origin iframe), it just covers it with a matching
                block. Position/size may need tweaking if their toolbar
                layout changes — remove this div if it ever misaligns. */}
            {/* <div className="flipbook-logo-mask" aria-hidden="true" /> */}
          </div>
        </div>
      ) : (
        <div className="magazine-flipbook magazine-flipbook-empty" id="magazine-flipbook">
          <p>The digital flipbook for this edition isn't available yet — check back soon.</p>
        </div>
      )}

      {/* ── Featured Stories ── */}
      <div className="featured-stories">
        <div className="fs-heading">
          <span className="fs-tab">Featured Stories</span>
          {/* <p className="fs-subtitle">Hand-picked reads from this edition</p> */}
        </div>

        <div className="fs-grid">
          {FEATURED_STORIES.map((story, i) => (
            <Link className="fs-card" to={`/article/${story._id}`} key={story._id} style={{ '--i': i }}>
              <div className="fs-img">
                <img src={story.imageUrl} alt={story.title} loading="lazy" />
                {/* <span className="fs-index">{String(i + 1).padStart(2, '0')}</span>
                {story.category && <span className="fs-category">{story.category}</span>} */}
              </div>
              <div className="fs-body">
                <h3 className="fs-title">{story.title}</h3>
                <p className="fs-excerpt">{story.excerpt}</p>
                <span className="fs-btn">Read More</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}